import { useState } from "react";
import { subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

const getRoleUUID = createUUID();
const createRoleUUID = createUUID();
const deleteRoleUUID = createUUID();

export function useManageRoleViewModel() {
  const [roles, setRoles] = useState([]);
  const stateManager = useComponentState();
  const [openAddDrawer, setOpenAddDrawer] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

  const getRoles = () => {
    stateManager.abort(getRoleUUID);
    stateManager.run(async () => {
      const response = await subscriptionService.roles.getAll({
        sort: "name asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setRoles(response.data);
      }
    }, getRoleUUID);
  };

  const createRole = (data) => {
    stateManager.abort(createRoleUUID);
    return stateManager.run(
      async () =>
        subscriptionService.roles.create({
          data,
          toastMessageConfig: {
            success: {
              text: `${data.name} was created successfully.`,
            },
            failure: {
              text: `Failed to create ${data.name}.`,
            },
          },
        }),
      createRoleUUID
    );
  };

  const deleteRole = (id, data) => {
    stateManager.abort(deleteRoleUUID);
    return stateManager.run(
      async () =>
        subscriptionService.roles.delete({
          id,
          data,
          toastMessageConfig: {
            success: {
              text: ` ${data.name} was deleted successfully.`,
            },
            failure: {
              text: `Failed to delete ${data.name}.`,
            },
          },
        }),
      deleteRoleUUID
    );
  };

  return {
    roles,
    stateManager,
    openAddDrawer,
    selectedItem,
    isOpenDeleteModal,
    getRoles,
    deleteRole,
    createRole,
    setOpenAddDrawer,
    setSelectedItem,
    setIsOpenDeleteModal,
  };
}
